// events.js
export const logoEvent = new EventTarget();
